import { useEffect, useState } from "react";
import { api, fileUrl, waLink } from "@/lib/api";
import { useSite } from "@/lib/site";

export default function AdSlot({ placement, zone = "", title, emptyText = true, testid = "ad-slot" }) {
  const { settings } = useSite();
  const [ads, setAds] = useState([]);
  useEffect(() => {
    api.get("/public/ads", { params: { placement, zone } }).then((r) => setAds(r.data)).catch(() => {});
  }, [placement, zone]);

  const click = async (ad) => {
    const r = await api.post(`/public/ads/${ad.id}/click`).catch(() => null);
    const url = r?.data?.url || ad.url;
    if (url) window.open(url, "_blank", "noopener");
  };

  if (!ads.length) {
    if (!emptyText) return null;
    return (
      <div className="rounded-2xl border border-dashed border-slate-300 p-8 text-center bg-white" data-testid={`${testid}-empty`}>
        <p className="eyebrow mb-2">Espacio publicitario</p>
        <p className="text-slate-600 text-sm mb-4">¿Ofreces servicios para quienes se mudan a Punta Cana? Anúnciate con SoloRentaPC.</p>
        <a href={waLink(settings.whatsapp, "Hola SoloRentaPC, quiero información para anunciarme en su plataforma.")} target="_blank" rel="noreferrer" className="text-sm font-semibold text-[#FF3333]" data-testid={`${testid}-advertise`}>Quiero anunciarme →</a>
      </div>
    );
  }
  return (
    <div className="space-y-4" data-testid={testid}>
      {title && <h3 className="font-semibold">{title}</h3>}
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {ads.map((ad) => (
          <button key={ad.id} onClick={() => click(ad)} className="text-left rounded-2xl overflow-hidden border border-slate-200 bg-white hover:shadow-lg transition-shadow" data-testid={`ad-card-${ad.id}`}>
            {ad.image && <div className="aspect-[16/9] bg-slate-100"><img src={fileUrl(typeof ad.image === "string" ? ad.image : ad.image?.url)} alt={ad.title} className="w-full h-full object-cover" /></div>}
            <div className="p-5 space-y-1.5">
              <span className="inline-block text-[10px] uppercase tracking-wider font-bold bg-red-50 text-red-600 border border-red-200 rounded-full px-2 py-0.5">Patrocinado</span>
              <p className="font-semibold">{ad.title}</p>
              {ad.text && <p className="text-sm text-slate-600 line-clamp-2">{ad.text}</p>}
              {ad.category && <p className="text-xs text-slate-400">{ad.category}</p>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
